import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { Textarea } from '@root/shared/ui-kit'

import type { AsyncStateN } from '@blade/std-lib'

type ReportFormProps = {
  state: AsyncStateN.AsyncStateN<unknown, unknown>
  onSubmit: (values: ReportFormValues) => void
}

export type ReportFormValues = {
  readonly reason: string
  readonly additionalInformation?: string
}

const ADDITIONAL_INFORMATION_MAX_LENGTH = 1200
const REASON_MAX_LENGTH = 500

export const ReportForm: React.FC<ReportFormProps> = ({ onSubmit, state }) => {
  const { t } = useTranslation()

  const form = useForm<ReportFormValues>({
    mode: 'all',
    defaultValues: {
      reason: '',
      additionalInformation: '',
    },
  })

  const handleSubmit = form.handleSubmit((values) => onSubmit(values))

  return (
    <Form onSubmit={handleSubmit}>
      {/* TODO: Ivan use drop down selector for reason */}
      <Controller
        rules={{ required: t('validation.required') }}
        control={form.control}
        disabled={state.loading}
        name="reason"
        render={({ field, fieldState }) => (
          <Textarea
            {...field}
            required
            emojiPicker
            label={t('common.reason')}
            errorMessage={fieldState.error?.message}
            maxLength={REASON_MAX_LENGTH}
            size="m"
          />
        )}
      />
      <Controller
        control={form.control}
        disabled={state.loading}
        name="additionalInformation"
        render={({ field, fieldState }) => (
          <Textarea
            {...field}
            emojiPicker
            label={t('common.additional_information')}
            errorMessage={fieldState.error?.message}
            maxLength={ADDITIONAL_INFORMATION_MAX_LENGTH}
            size="m"
          />
        )}
      />
      <ReportButton
        disabled={!form.formState.isValid || state.loading}
        busy={state.loading}
        type="submit"
        variant="solid"
        color="primary"
        radius="rounded"
      >
        {t('common.report')}
      </ReportButton>
    </Form>
  )
}

const Form = styled.form`
  display: grid;
  gap: 20px;
`

const ReportButton = styled(Button)``
